import React from 'react'

function Timer({timeLeft}) {
    return (
        <div>
            <h1 className='p-1 flex flex-col justify-center items-center text-xl mt-2'>Time : {timeLeft}</h1>
        </div>
    )
}
export default Timer